export const getMessageContentElementId = (messageId: string) =>
  `message_content_${messageId}`;
